//re-direct NZ visitors to .co.nz and non-NZ to .com
(function() {
  try {
    var host = window.location.hostname.toLowerCase();
    var params = new URLSearchParams(window.location.search);

    if (!host.includes('.com') && !host.includes('.co.nz')) return;

    if (/staging|test|dev|localhost|shopifypreview\.com|admin\.shopify\.com|0xemku-rz\.myshopify\.com/.test(host)) return;

    // If an explicit country is supplied, lock this domain for the browser session
    if (params.has('country')) {
      sessionStorage.setItem('market_domain_locked', 'true');
      return;
    }

    // Keep subsequent page views on the same domain for this session.
    // Use e.g. ?country=NZ in Google Ads / product feeds to prevent destination mismatch
    if (sessionStorage.getItem('market_domain_locked') === 'true') return;

    if (window.location.search.includes('no_redirect=1')) return;
    if (window.location.search.includes('shpxid=')) return;
    if (localStorage && localStorage.getItem('force_domain') === 'true') return;

    function buildUrl(newHost) {
      return window.location.protocol + '//' + newHost +
             window.location.pathname + window.location.search + window.location.hash;
    }

    fetch('/browsing_context_suggestions.json', { 
      cache: 'no-store',
      credentials: 'same-origin'
    })
    .then(function(r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function(data) {
      var country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      if (!country) return;

      if (country === 'NZ') {
        if (!host.includes('.co.nz')) {
          var nzHost = host.replace(/\.com$/, '.co.nz');
          window.location.replace(buildUrl(nzHost));
        }
      } else {
        if (!host.includes('.com')) {
          var comHost = host.replace(/\.co\.nz$/, '.com');
          window.location.replace(buildUrl(comHost));
        }
      }
    })
    .catch(function() {});
  } catch (e) {
    console.warn('Geo redirect script error:', e);
  }
})();

//change size labels for non-AU/GB/NZ visitors to US sizes
(function () {
  // ── Market check ──────────────────────────────────────────────────────────
  const EXEMPT_COUNTRIES = ['AU', 'GB', 'NZ'];
  const country = window.Shopify?.country || '';   // e.g. "AU", "GB", "NZ", "US"

  if (EXEMPT_COUNTRIES.includes(country.toUpperCase())) return;

  // ── Selectors (both product-card and PDP) ─────────────────────────────────
  const SELECTORS = [
  // Product card (hover)
  '.product-card-wrapper .card__content .card__information .hover_content .option_size .variant_normal label',
  // PDP
  '.product__info-container .slect_variant_size .product-form__input input[type=radio] + label',
  // Cart drawer
  '#CartDrawer .cart-item__details dl .product-option dd',
  // Cart page
  '.cart-item__details .cart_item_content dl .product-option dd',
];

  // ── Conversion: subtract 4 from any leading integer ──────────────────────
  function convertLabel(label) {
    // Walk text nodes directly inside the label (skips .visually-hidden span)
    label.childNodes.forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) return;

      const trimmed = node.textContent.trim();
      const num = parseInt(trimmed, 10);

      if (!isNaN(num)) {
        // Preserve surrounding whitespace, replace just the numeral
        node.textContent = node.textContent.replace(trimmed, 'US' + String(num - 4));
      }
    });
  }

  // ── Run on existing DOM ───────────────────────────────────────────────────
  function convertAll() {
    SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach(convertLabel);
    });
  }

  // ── Also watch for dynamically injected labels (AJAX sections, etc.) ─────
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        SELECTORS.forEach((sel) => {
          // Check if the added node itself matches, or contains matches
          if (node.matches?.(sel)) convertLabel(node);
          node.querySelectorAll?.(sel).forEach(convertLabel);
        });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Run once immediately, and again after DOM is fully ready
  convertAll();
  document.addEventListener('DOMContentLoaded', convertAll);
})();